export const LOADER_GOAL_PER_YEAR = "LOADER_GOAL_PER_YEAR";
export const GET_GOAL_PER_YEAR = "GET_GOAL_PER_YEAR";
export const GOAL_PER_YEAR_FAIL = "GOAL_PER_YEAR_FAIL";
export const SAVE_LOADER_GOAL_PER_YEAR = "SAVE_LOADER_GOAL_PER_YEAR";
export const FORM_GOAL_PER_YEAR_FAIL = "FORM_GOAL_PER_YEAR_FAIL";
